"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoSettings = void 0;

var _VideoSettings = require("./controllers/VideoSettings");

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
var useVideoSettings = function useVideoSettings(ref) {
  var controller = null;

  if (ref) {
    controller = _VideoSettings.VideoSettings.getInstance(ref.current);
  }

  return {
    loop: controller.loop,
    muted: controller.muted,
    zoom: controller.zoom,
    locked: controller.locked,
    setLocked: function setLocked(lockedState) {
      console.log("useVideoSettings.setLocked", lockedState, controller.locked);
      controller.locked = lockedState;
    },
    setLoop: function setLoop(loopState) {
      console.log("useVideoSettings.setLoop", loopState, controller.loop);
      controller.loop = loopState;
    }
  };
};

exports.useVideoSettings = useVideoSettings;